/*
 * BouncingDots — pure CSS animation, zero JS after mount.
 * Uses translateY only → runs on the GPU compositor thread.
 * Import and drop inside any `relative overflow-hidden` container.
 *
 * Usage:  <BouncingDots />          (default: dark dots)
 *         <BouncingDots light />    (white dots for dark bg sections)
 *         <BouncingDots count={8} /> (fewer dots)
 */

/* Staggered positions — spread across the section without clustering */
const DOTS = [
  { top: '8%',  left: '4%',   delay: '0s'    },
  { top: '14%', left: '91%',  delay: '0.55s' },
  { top: '32%', left: '8%',   delay: '1.1s'  },
  { top: '28%', left: '78%',  delay: '0.3s'  },
  { top: '52%', left: '2%',   delay: '0.85s' },
  { top: '48%', left: '94%',  delay: '1.4s'  },
  { top: '67%', left: '22%',  delay: '0.2s'  },
  { top: '72%', left: '62%',  delay: '1.65s' },
  { top: '85%', left: '11%',  delay: '0.7s'  },
  { top: '88%', left: '85%',  delay: '0.45s' },
  { top: '42%', left: '47%',  delay: '1.2s'  },
  { top: '19%', left: '55%',  delay: '0.95s' },
];

const BouncingDots = ({ count = 12, light = false }) => (
  <div aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
    {DOTS.slice(0, count).map((d, i) => (
      <span
        key={i}
        className="bounce-dot"
        style={{
          top: d.top,
          left: d.left,
          animationDelay: d.delay,
          background: light ? '#ffffff' : '#1C2E1E',
          opacity: light ? 0.18 : 0.09,
        }}
      />
    ))}
  </div>
);

export default BouncingDots;
